import { Component, OnInit } from '@angular/core';
import { Product } from '../Models/product';
import { ProductFilter } from '../Models/filter';
import { ProductListComponent } from './product.list';


@Component({
  selector: 'highlights',
  templateUrl: '../Templates/highlights.html',
})


export class HighlightsComponent extends ProductListComponent implements OnInit {

  filter: ProductFilter;

  ngOnInit(): void {

    this.filter = new ProductFilter();

    this.filter.setval('tag', 'home');

    this.productService.list(this.filter)
      .subscribe(data => {
        this.products = data;
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/highlights.ts